import script from "./MainPermitionsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainPermitionsTab.vue?vue&type=script&setup=true&lang=ts"

import "./MainPermitionsTab.vue?vue&type=style&index=0&id=28dbe151&scoped=true&lang=scss"
import "./MainPermitionsTab.vue?vue&type=style&index=1&id=28dbe151&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28dbe151"]])

export default __exports__